import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import store from './../../../store/store.module';
import {
  FETCH_PAYMENTS_REQUESTED, SELECT_ALL_PAYMENT,
  SELECT_ALL_VISIBLE_PAYMENT
} from './list.actions';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import {DOWNLOAD_REQUESTED} from "../../product/list/list.actions";
import {CREATE_PAYMENT_ITEM_REQEUSTED} from "../pay/pay.actions";
import {
  CANCEL_PAYMENT_REQUESTED,
  GET_PAYMENT_METHODS_REQUESTED,
  SEND_PAYMENT_TO_ACCOUNTING_REQUESTED
} from "../edit/edit.actions";
import {UtilityService} from "../../../common/services/utility/utility.service";
import Redirect from "../../../models/Redirect";
const PENDING_FILTER = 'PENDING';
const COMPLETED_FILTER = 'COMPLETED';

@Component({
  selector: 'app-send',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  public navigationSubscription: Subscription;
  public store = store;
  @ViewChild('popup') private popup: SwalComponent;
  public payment_status = {
    PENDING: PENDING_FILTER,
    COMPLETED: COMPLETED_FILTER
  };
  public filters = {};
  public filterPaymentUntouched = true;
  public utilityService;
  public totalAmount = 0;
  private orders = {
    created_at: null,
    id: null,
    email: null
  };
  public untouched = true;

  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private router: Router, utilityService: UtilityService) {
    this.utilityService = utilityService;
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (this.activeRouter.snapshot.params.type !== this.filters['payment_type']) {
        this.filters = {};
        this.untouched = true;
      }
      if (!_.isUndefined(this.activeRouter.snapshot.queryParams.filters)) {
        let filters = this.activeRouter.snapshot.queryParams.filters;
        if (filters) {
          this.filters = JSON.parse(filters);
        }
      } else {
        this.filters['status'] = PENDING_FILTER;
      }
      if (!_.isUndefined(this.activeRouter.snapshot.params.type)) {
        this.filters['payment_type'] = this.activeRouter.snapshot.params.type.toUpperCase();
      }
      if (!_.isUndefined(this.activeRouter.snapshot.queryParams.untouched)) {
        this.untouched = false;
      }
      if (!_.isUndefined(this.activeRouter.snapshot.queryParams.orders)) {
        let orders = this.activeRouter.snapshot.queryParams.orders;
        if (orders) {
          this.orders = JSON.parse(orders);
        }
      }
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
        store.dispatch({
          type: GET_PAYMENT_METHODS_REQUESTED
        });
        store.dispatch({
          type: FETCH_PAYMENTS_REQUESTED,
          data: {
            pagination: this.getQuery(),
            filters: this.filters,
            sorts: this.orders,
            defaultSelection: true,
            untouched: this.untouched
          }
        });
        this.untouched = false;
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  public getQuery(): object {
    let supportedParams = ['sort', 'constraints', 'page', 'per_page', 'search', 'skus', 'filter_payment_status'];
    let queryParams = { page: 1 };
    if (_.keys(this.activeRouter.snapshot.queryParams).length > 0) {
      queryParams = _.assign(queryParams, this.activeRouter.snapshot.queryParams);
    }

    return _.pick(queryParams, supportedParams);
  }
  _filter(key, value) {
    if (value === '') {
      delete this.filters[key];
    } else {
      this.filters[key] = value;
    }
  }

  markAsPaid() {
    let bulkData = [].concat.apply([], store.getState().Payment.list.checkedItems.filter(s => s.checked === true && s.status === 'PENDING').map(s => {
      return {
        id: s.id,
        type: 'full_payment',
        comment: ''
      };
    }));
    if (bulkData.length > 0) {
      store.dispatch({ type: CREATE_PAYMENT_ITEM_REQEUSTED, data: bulkData, next: 'payment/send'});
    }
  }

  payThis(id) {
    store.dispatch({ type: CREATE_PAYMENT_ITEM_REQEUSTED, data: [{
        id: id,
        type: 'full_payment',
        comment: ''
      }], next: 'payment/send'});
  }
  getSelectedNum() {
    if (store.getState().Payment.list.fetched) {
      if (store.getState().Payment.list.allChecked) {
        return store.getState().Payment.list.pagination.total;
      } else {
        let curItems = store.getState().Payment.list.items;
        let curItemIds = curItems.map(s => s.id);
        let checkedItems = store.getState().Payment.list.checkedItems
          .filter(s => s.checked === true)
          .filter(s => curItemIds.indexOf(s.id) === -1)
          .map(s => s.id);
        let selectedItems = checkedItems.concat(curItems.filter(s => s.checked === true));
        this.totalAmount = selectedItems.reduce((total, curVal) => {
          total += curVal.plus_amount;
          return total;
        }, 0);
        return selectedItems.length;
      }
    } else {
      return 0;
    }
  }
  editThis(item) {
    this.utilityService.nextPageWithReferer([`/payment/edit/${item.id}`], new Redirect('payment/' + item.payment_type.toLowerCase(), {
      filters: JSON.stringify(this.filters),
      orders: JSON.stringify(this.orders),
      untouched: true,
      search: this.getQuery()['search']
    }));
  }
  cancelThis(item) {
    store.dispatch({
      type: CANCEL_PAYMENT_REQUESTED,
      data: {
        id: item.id
      },
      next: 'payment/send',
      nextParams: {
        filters: JSON.stringify(this.filters),
        orders: JSON.stringify(this.orders),
        untouched: true,
        search: this.getQuery()['search']
      }});
  }
  paySingle(item) {
    this.utilityService.nextPageWithReferer([`/payment/pay/${item.id}`], new Redirect('payment/' + item.payment_type.toLowerCase(), {
      filters: JSON.stringify(this.filters),
      orders: JSON.stringify(this.orders),
      untouched: true,
      search: this.getQuery()['search']
    }));
  }
  getDownloadData({paymentMethod = null, malaysianProduct = false, paymentType = 'SEND', wholeExport = false}) {
    let data = {
      filter: {
        ...this.filters
      },
      search: null,
      sorts: this.orders
    };
    if (paymentMethod) {
      data.filter['payment_method'] = paymentMethod;
    }
    if (paymentType) {
      data.filter['payment_type'] = paymentType;
    }
    if (malaysianProduct) {
      data.filter['malaysian_product'] = true;
    }
    if (wholeExport) {
      data.filter['whole_export'] = wholeExport;
    }
    if (store.getState().Payment.list.allChecked === false) {
      let selectedIds = store.getState().Payment.list.checkedItems.filter(s => s.checked === true);
      if (selectedIds.length > 0) {
        data.filter['containid'] = selectedIds.map(s => s.id).join(',');
      }
    }
    return data;
  }
  download(id) {
    let data = this.getDownloadData({paymentMethod: id, malaysianProduct: null, paymentType: 'SEND'});
    store.dispatch({
      type: DOWNLOAD_REQUESTED, data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'payment',
        extension: 'txt',
        ...data
      }
    });
  }
  downloadMalaysia() {
    let data = this.getDownloadData({paymentMethod: null, malaysianProduct: true, paymentType: 'SEND'});
    store.dispatch({
      type: DOWNLOAD_REQUESTED, data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'payment',
        extension: 'csv',
        ...data
      }
    });
  }
  downloadXero() {
    let data = this.getDownloadData({paymentMethod: null, malaysianProduct: false, paymentType: 'COLLECT'});
    store.dispatch({
      type: DOWNLOAD_REQUESTED, data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'payment',
        extension: 'csv',
        ...data
      }
    });
  }
  downloadCsv() {
    let data = this.getDownloadData({paymentType: this.filters['payment_type'], wholeExport: true});
    store.dispatch({
      type: DOWNLOAD_REQUESTED, data: {
        mediaPath: store.getState().RootReducer.config.mediaUrl,
        type: 'payment',
        extension: 'csv',
        ...data
      }
    });
  }
  sortBy(field) {
    for (let prop in this.orders) {
      if (prop === field) {
        if (this.orders[field] === null) {
          this.orders[field] = '-';
        } else {
          if (this.orders[field] === '-') {
            this.orders[field] = '';
          } else if (this.orders[field] === '') {
            this.orders[field] = null;
          }
        }
      }
    }
    this.router.navigate(['payment/' + this.filters['payment_type'].toLowerCase()], { queryParams: {
        filters: JSON.stringify(this.filters),
        orders: JSON.stringify(this.orders)
      }});
  }
  resetFilter() {
    this.filters = {};
    this.filterPaymentUntouched = true;
    store.dispatch({ type: FETCH_PAYMENTS_REQUESTED, data: {
      filters: this.filters,
      sort: this.getQuery()['sort'],
      pagination: this.getQuery()
    } });
  }
  filter(key, value) {
    this._filter(key, value);
    this.filterPaymentUntouched = false;
    let params = _.assign(this.getQuery(), {page: 1});
    params['filters'] = JSON.stringify(_.omit(this.filters, ['payment_type']));
    if (this.activeRouter.snapshot.queryParams.search) {
      params['search'] = this.activeRouter.snapshot.queryParams.search;
    }
    this.router.navigate(['payment/' + this.filters['payment_type'].toLowerCase()], { queryParams: params});
  }
  toggleFilter(type, value) {
    if (this.filters[type] !== value) {
      this.filter(type, value);
    } else {
      this.filter(type, '');
    }
  }
  selectVisiblePayments(event) {
    store.dispatch({ type: SELECT_ALL_VISIBLE_PAYMENT, data: event.checked });
  }
  toggleAllPayments() {
    if (store.getState().Payment.list.allChecked) {
      store.dispatch({ type: SELECT_ALL_VISIBLE_PAYMENT, data: true });
    } else {
      store.dispatch({ type: SELECT_ALL_PAYMENT });
    }
  }
  getSelectText() {
    if (store.getState().Payment.list.allChecked) {
      return `Select payment on this page`;
    } else {
      return `Select all ${store.getState().Payment.list.pagination.total} payments`;
    }
  }
  havingPendingFilter() {
    if (this.filters['status'] === PENDING_FILTER) {
      return true;
    } else {
      return false;
    }
  }
  havingCompletedFilter() {
    if (this.filters['status'] === COMPLETED_FILTER) {
      return true;
    } else {
      return false;
    }
  }
  havingCollectFilter() {
    if (this.filters['payment_type'] === 'COLLECT') {
      return true;
    } else {
      return false;
    }
  }
  havingSendFilter() {
    if (this.filters['payment_type'] === 'SEND') {
      return true;
    } else {
      return false;
    }
  }
  isComplete(data, requiredVal) {
    if (!requiredVal) {
      return true;
    }
    if (requiredVal.length === 0) {
      return true;
    }
    if (!data) {
      return false;
    }
    for (let i = 0; i < requiredVal.length; i++) {
      if (!data[requiredVal[i]]) {
        return false;
      }
    }
    return true;
  }
  getAvailablePaymentMethod(items) {
    // return _.uniqBy(items.map(s => {
    //   if (s.default_payment_detail) {
    //     if (s.default_payment_detail.payment_method) {
    //       return s.default_payment_detail.payment_method;
    //     }
    //   }
    //   return null;
    // }).filter(s => !!s), 'id');
    return (store as any).getState().Payment.edit.paymentMethods.filter(s => s.name === 'TRANSFER');
  }
  sendToAccounting(payment) {
    store.dispatch({ type: SEND_PAYMENT_TO_ACCOUNTING_REQUESTED, data: payment.id });
  }
}
